const organization = {
  getOrganization: async function(organizationId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{ organization(id: ` +
          parseInt(organizationId) +
          `) {
          Organization_Id
          Name
          Parent_Organization_Id
          Organization_Type_Id
          Users {
            User_Id
            First_Name
            Last_Name
            Email
            Phone
            Account_Id
            Organization_Id
            Permissions {
              UserPermission_Id
              Organization {
                Organization_Id
                Name
              }
              Permission {
                Permission_Id
                Title
              }
            }
          }
          Child_Organizations{
            Organization_Id
            Name
            Parent_Organization_Id
            Organization_Type_Id
            Users {
              User_Id
              First_Name
              Last_Name
              Email
              Phone
              Account_Id
              Organization_Id
              Permissions {
                UserPermission_Id
                Organization {
                  Organization_Id
                  Name
                }
                Permission {
                  Permission_Id
                  Title
                }
              }
            }
          }
        }
      }`
      })
      .then(r => {
        return r.data.organization;
      });
  },
  createOrganization: async function(organizationToAdd) {
    var query = `
      mutation($name: String!, $accountId: Int!, $organizationTypeId: Int!, $parentOrganizationId: Int!) {
        CreateOrganization(name: $name, accountId: $accountId, organizationTypeId: $organizationTypeId, parentOrganizationId: $parentOrganizationId) {
          Organization_Id
        }
      }`;
    var variables = {
      name: organizationToAdd.Name,
      accountId: parseInt(organizationToAdd.Account_Id),
      organizationTypeId: parseInt(organizationToAdd.Organization_Type_Id),
      parentOrganizationId: parseInt(organizationToAdd.Parent_Organization_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      organizationToAdd.Organization_Id =
        r.data.CreateOrganization.Organization_Id;
      return organizationToAdd;
    });
  },

  updateOrganization: async function(organizationToUpdate) {
    var query = `
      mutation($organizationId: Int! $name: String!, $accountId: Int!, $organizationTypeId: Int!, $parentOrganizationId: Int!) {
        UpdateOrganization(organizationId: $organizationId, name: $name, accountId: $accountId, organizationTypeId: $organizationTypeId, parentOrganizationId: $parentOrganizationId) {
          Organization_Id
        }
      }`;
    var variables = {
      organizationId: parseInt(organizationToUpdate.Organization_Id),
      name: organizationToUpdate.Name,
      accountId: parseInt(organizationToUpdate.Account_Id),
      organizationTypeId: parseInt(organizationToUpdate.Organization_Type_Id),
      parentOrganizationId: parseInt(
        organizationToUpdate.Parent_Organization_Id
      )
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return organizationToUpdate;
    });
  },

  deleteOrganization: async function(organizationId) {
    var query = `
      mutation($organizationId: Int!) {
        DeleteOrganization(organizationId: $organizationId)
      }`;
    var variables = {
      organizationId: parseInt(organizationId)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      return r.data;
    });
  },

  getOrganizationTypes: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ organizationTypes {
          Organization_Type_Id
          Name
          Description
        }
      }`
      })
      .then(r => {
        return r.data.organizationTypes;
      });
  },

  getUsableOrganizationTypes: async function(
    allOrganizationTypes,
    myOrganizationTypes
  ) {
    var orgTypesToReturn = [];
    if (myOrganizationTypes.includes(1)) {
      allOrganizationTypes
        .filter(ot => ot.Organization_Type_Id != 1)
        .forEach(type => {
          orgTypesToReturn.push(type);
        });
    }
    if (myOrganizationTypes.includes(2)) {
      allOrganizationTypes
        .filter(
          ot => ot.Organization_Type_Id >= 2 && ot.Organization_Type_Id != 6
        )
        .forEach(type => {
          if (!orgTypesToReturn.includes(type)) {
            orgTypesToReturn.push(type);
          }
        });
    }
    if (myOrganizationTypes.includes(3)) {
      allOrganizationTypes
        .filter(ot => ot.Organization_Type_Id == 3)
        .forEach(type => {
          if (!orgTypesToReturn.includes(type)) {
            orgTypesToReturn.push(type);
          }
        });
    }
    if (myOrganizationTypes.includes(4)) {
      allOrganizationTypes
        .filter(
          ot => ot.Organization_Type_Id == 4 || ot.Organization_Type_Id == 5
        )
        .forEach(type => {
          if (!orgTypesToReturn.includes(type)) {
            orgTypesToReturn.push(type);
          }
        });
    }
    if (myOrganizationTypes.includes(5)) {
      allOrganizationTypes
        .filter(ot => ot.Organization_Type_Id == 5)
        .forEach(type => {
          if (!orgTypesToReturn.includes(type)) {
            orgTypesToReturn.push(type);
          }
        });
    }
    return orgTypesToReturn;
  }
};

export { organization };
